export default __webpack_public_path__ + "static/media/instagram.26cd1ce1.svg";